import _ from 'lodash';

function PlayerCtrl($window, $rootScope, $scope, $state, $stateParams, $timeout, $compile, $element, ChartGeneratorService, PlayerService, AppSettings, CommonService, AppContextService, PlanService, AnalysisService, toastr) {
  'ngInject';

  window['scope'] = $scope;

  const h337 = require('heatmap.js');
  const Flatpickr = require('flatpickr');
  const Korean = require("flatpickr/dist/l10n/ko.js").ko;

  // ViewModel
  const vm = this;

  vm.appContext = AppContextService.context;
  vm.typeCode = $stateParams.type_code;

  var getGameInfo = function() {
    var data = {
      login_id: vm.appContext.user.login_id,
      uuid: vm.appContext.user.uuid,
      game_id: $stateParams.id,
    };
    PlanService.getGameInfo(data)
      .then(function (res) {
        vm.date = res.data.date;
      })
      .catch(function (error) {
        console.log('ERROR ' + error);
      });
  }
  var getTrainingInfo = function() {
    var data = {
      login_id: vm.appContext.user.login_id,
      uuid: vm.appContext.user.uuid,
      training_root_id: $stateParams.id,
    };

    PlanService.getTraining(data)
      .then(function (res) {
        vm.date = res.data.date;
      });
  };
  if (vm.typeCode === 'game') {
    getGameInfo();
  } else if (vm.typeCode === 'training') {
    getTrainingInfo();
  }


  // 임시 - headcoach@kfa.or.kr 으로 로그인한 경우
  if (vm.appContext.user.user_id == '2391' && $state.current.name === 'Service.playerDetail') {
    vm.appContext.role2 = 'player';
  } else if (vm.appContext.user.user_id == '2391') {
    vm.appContext.role2 = 'coaching_staff';
  }

  vm.openStatAnalysis = function() {
    window.open('http://sgsmanager.com/lab/stat-analysis/');
  };


  // 선수로 로그인한 경우
  if (vm.appContext.role2 === 'player') {
    $state.go('Service.playerDetail', {
      user_id: vm.appContext.user.user_id
    });
    return;
  }
  // 팬이 선택한 user_id
  else if ($stateParams.fan_user_id) {
    $state.go('Service.playerDetail', {
      user_id: $stateParams.fan_user_id
    });
    return;
  }


  let liquidGaugeSize = {
    width: '50px',
    height: '50px'
  };



  var bioData;


  // sidebar 초기화
  $rootScope.$emit('base:sidebarEvent', 'open');


  let number_format = d3.format(',');

  vm.bioSelected = [];
  vm.bioItems = AppSettings.bioItems;

  vm.toggle = function (item) {
    if (vm.bioList.length !== vm.users.length) {
      toastr.info('현재 데이터를 불러오는 중입니다. 데이터 처리에 1분정도 시간이 소요될 수 있습니다. 잠시후 다시 선택해주세요');
      return;
    }

    var idx = vm.bioSelected.indexOf(item.type);
    if (idx >= 0) {
      vm.bioSelected.splice(idx, 1);
    } else {
      vm.bioSelected.push(item.type);
      if (vm.bioSelected.length > 4) vm.bioSelected.shift();
    }

    // button on/off 표시
    for (let i = 0; i < vm.bioItems.length; i++) {
      if (vm.bioSelected.indexOf(vm.bioItems[i].type) >= 0) {
        vm.bioItems[i].selected = true;
      } else {
        vm.bioItems[i].selected = false;
      }
    }

    render();
  };


  var watch;
  if ($stateParams.type_code === 'team') {
    watch = '[vm.appContext.players.all]'
  } else if ($stateParams.type_code === 'game') {
    watch =
      '[vm.appContext.players.game.my_team.entryMain,' +
      'vm.appContext.players.game.my_team.entryBackup,' +
      'vm.appContext.players.game.oppo_team.entryMain,' +
      'vm.appContext.players.game.oppo_team.entryBackup]'
  } else if ($stateParams.type_code === 'training') {
    watch = '[vm.appContext.players.training.my_team.entryMain]'
  }

  $scope.$watch(watch, function (newVal, oldVal) {
    if (newVal) {
      _.forEach(newVal, function (arr) {
        if (!arr) {
          return;
        }
      })

      $timeout(function () {
        vm.players = [];
        _.forEach(newVal, function (arr) {
          vm.players = _.concat(vm.players, arr);
        })
        render();
      });

    }
  }, true)



  vm.setTeamDistanceInfo = function (userId, tId, type) {

    var targetData = _.find(vm.bioList, {
      user_id: userId
    })['distance'][0];

    let chartHtml = `<div class="w3-cell-row" style="height:100%">
        <div id="${type}-main-chart-${tId}" class="w3-cell w3-cell-middle" style="width:50%; height:100%">
          </div>
        <div class="w3-cell w3-cell-middle" style="width:50%; height:100%">
          거리<br><strong>${targetData.current}</strong>km
          </div>
      </div>`;
    angular.element('#' + tId).html(chartHtml);

    let targetId = "#" + 'distance-main-chart-' + tId;

    let distanceMainChart;
    if (!distanceMainChart) {
      let configuration = {
        size: 80,
        clipWidth: 64,
        clipHeight: 56,
        ringWidth: 10,
        maxValue: Number(targetData.max),
        transitionMs: 4000,
      }
      distanceMainChart = ChartGeneratorService.createCircularGauge(targetId, configuration);
      distanceMainChart.render();
    }
    distanceMainChart.update(Number(targetData.current)); //distance.current
  };

  vm.setTeamOxygenInfo = function (userId, tId, type) {

    var targetData = _.find(vm.bioList, {
      user_id: userId
    })['oxyzen'][0];
    let chartHtml = `<div class="w3-cell-row" style="height:100%">
        <div id="oxygen-main-chart-${tId}" class="w3-cell w3-cell-middle" style="width:50%; height:100%">
          </div>
        <div class="w3-cell w3-cell-middle" style="width:50%; height:100%">
          Sp02<br><strong>${targetData.current}</strong>km
          </div>
      </div>`;

    angular.element('#' + tId).html(chartHtml);

    let targetId = "#" + 'oxygen-main-chart-' + tId;

    let value = Number(targetData.current); //heartbeat.current
    //heartbeat.max 값이 0일경우 챠트 에러가 발생 하므로 임의로 100 부여
    let max = targetData.max ? Number(targetData.max) : 100;

    //liquid gauge chart
    let oxygenMainChart;
    let options = ChartGeneratorService.getLiquidGaugeOptions();
    options.targetId = targetId;
    options.svgId = 'oxygen-liquid';
    options.circleColor = '#3187c5';
    options.textColor = '#3187c5';
    options.waveColor = '#3187c5';
    options.size = liquidGaugeSize;
    let dataValue = (value / max) * 100;
    if (!oxygenMainChart) {
      oxygenMainChart = ChartGeneratorService.loadLiquidFillGauge(Math.round(dataValue), options);
      oxygenMainChart['type'] = 'liquid';
    } else {
      oxygenMainChart.update(Math.round(dataValue));
    }

  };

  vm.setTeamHeartbeatInfo = function (userId, tId, type) {

    var targetData = _.find(vm.bioList, {
      user_id: userId
    })['heartbeat'][0];

    let chartHtml = `<div class="w3-cell-row" style="height:100%">
        <div id="chart-${tId}" class="w3-cell w3-cell-middle" style="width:50%; height:100%">
          </div>
        <div class="w3-cell w3-cell-middle" style="width:50%; height:100%">
          심박수<br><strong>${targetData.current}</strong>km
          </div>
      </div>`;
    angular.element('#' + tId).html(chartHtml);

    let targetId = "#" + 'chart-' + tId;

    let value = Number(targetData.current); //heartbeat.current
    //heartbeat.max 값이 0일경우 챠트 에러가 발생 하므로 임의로 100 부여
    let max = targetData.max ? Number(targetData.max) : 100;

    //liquid gauge chart
    let heartbeatMainChart;
    let options = ChartGeneratorService.getLiquidGaugeOptions();
    options.targetId = targetId;
    options.svgId = 'heartbeat-liquid';
    options.circleColor = '#c833c8';
    options.textColor = '#c833c8';
    options.size = liquidGaugeSize;
    let dataValue = (value / max) * 100;
    if (!heartbeatMainChart) {
      console.log('chart load...')
      heartbeatMainChart = ChartGeneratorService.loadLiquidFillGauge(Math.round(dataValue), options);
      heartbeatMainChart['type'] = 'liquid';
    } else {
      console.log('chart update....')
      heartbeatMainChart.update(Math.round(dataValue));
    }
  };

  vm.setTeamLacticInfo = function (userId, tId, type) {

    var targetData = _.find(vm.bioList, {
      user_id: userId
    })['lactic'][0];

    // let chartHtml = "<div id='lactic-main-chart-" + tId + "' class='team-main-min-chart-container'></div>" +
    //   "<p>젖산<br><strong>" + targetData.current + "</strong>mg/dℓ</p>";
    let chartHtml = `<div class="w3-cell-row" style="height:100%">
        <div id="lactic-main-chart-${tId}" class="w3-cell w3-cell-middle" style="width:50%; height:100%">
          </div>
        <div class="w3-cell w3-cell-middle" style="width:50%; height:100%">
          젖산<br><strong>${targetData.current}</strong>km
          </div>
      </div>`;
    angular.element('#' + tId).html(chartHtml);

    let targetId = "#" + 'lactic-main-chart-' + tId;

    let value = Number(targetData.current); //heartbeat.current
    //heartbeat.max 값이 0일경우 챠트 에러가 발생 하므로 임의로 100 부여
    let max = targetData.max ? Number(targetData.max) : 100;

    //liquid gauge chart
    let lacticMainChart;
    let options = ChartGeneratorService.getLiquidGaugeOptions();
    options.targetId = targetId;
    options.svgId = 'lactic-liquid';
    options.circleColor = '#c833c8';
    options.textColor = '#c833c8';
    options.size = liquidGaugeSize;
    let dataValue = (value / max) * 100;
    if (!lacticMainChart) {
      lacticMainChart = ChartGeneratorService.loadLiquidFillGauge(Math.round(dataValue), options);
      lacticMainChart['type'] = 'liquid';
    } else {
      lacticMainChart.update(Math.round(dataValue));
    }
  };

  vm.setTeamTemperatureInfo = function (userId, tId, type) {


    var targetData = _.find(vm.bioList, {
      user_id: userId
    })['temperature'][0];

    // let chartHtml = "<div id='temperature-main-chart-" + tId + "' class='team-main-min-chart-container'></div>" +
    //   "<p>체온<br><strong>" + targetData.current + "</strong>℃</p>";
    let chartHtml = `<div class="w3-cell-row" style="height:100%">
        <div id="temperature-main-chart-${tId}" class="w3-cell w3-cell-middle" style="width:50%; height:100%">
          </div>
        <div class="w3-cell w3-cell-middle" style="width:50%; height:100%">
          체온<br><strong>${targetData.current}</strong>℃
          </div>
      </div>`;
    angular.element('#' + tId).html(chartHtml);

    let targetId = "#" + 'temperature-main-chart-' + tId;

    let thermometerOptions = {
      targetId: targetId,
      svg_height: 70,
      svg_width: 70,
      svg_style: 'padding-top:3px;',
      max_temp: 44,
      min_temp: 32,
      current_temp: Number(targetData.current), //temperature.currnent
      topY: 5,
      bulb_radius: 9,
      tube_width: 11,
      tube_border_width: 1,
    };
    ChartGeneratorService.createThermometer(thermometerOptions);


  };



  vm.setTeamVelocityInfo = function (userId, tId, type) {

    var targetData = _.find(vm.bioList, {
      user_id: userId
    })['velocity'][0];

    // let chartHtml = "<div id='velocity-main-chart-" + tId + "' class='team-main-min-chart-container'></div>" +
    //   "<p>속도<br><strong>" + targetData.current + "</strong>m/s</p>";

    let chartHtml = `<div class="w3-cell-row" style="height:100%">
        <div id="${type}-main-chart-${tId}" class="w3-cell w3-cell-middle" style="width:50%; height:100%">
          </div>
        <div class="w3-cell w3-cell-middle" style="width:50%; height:100%">
          속도<br><strong>${targetData.current}</strong>km
          </div>
      </div>`;

    angular.element('#' + tId).html(chartHtml);

    let targetId = "#" + 'velocity-main-chart-' + tId;

    let velocityMainChart;
    if (!velocityMainChart) {
      let configuration = {
        size: 80,
        clipWidth: 64,
        clipHeight: 56,
        ringWidth: 10,
        maxValue: Number(targetData.max),
        transitionMs: 4000,
      }
      velocityMainChart = ChartGeneratorService.createCircularGauge(targetId, configuration)
      velocityMainChart.render();
    }
    velocityMainChart.update(Number(targetData.current)); //velocity.current

  };

  vm.setTeamWeightInfo = function (userId, tId, type) {


    var targetData = _.find(vm.bioList, {
      user_id: userId
    })['weight'][0];

    let chartHtml = `<div class="w3-cell-row" style="height:100%">
        <div id="${type}-main-chart-${tId}" class="w3-cell w3-cell-middle" style="width:50%; height:100%">
          </div>
        <div class="w3-cell w3-cell-middle" style="width:50%; height:100%">
          <strong>${targetData.current}</strong> kg in weight<br>
          </div>
      </div>`;
    angular.element('#' + tId).html(chartHtml);
    let targetId = 'weight-main-chart-' + tId;




    // let weightMainChart;
    // if (!weightMainChart) {
    //   let size = 90;
    //   weightMainChart = ChartGeneratorService.createWeightChart(targetId, 'weight', size);
    // }
    // ChartGeneratorService.updateWeightChart(targetData, weightMainChart, targetId);


    let weightMainChart;
    if (!weightMainChart) {
      let size = 70;
      weightMainChart = ChartGeneratorService.createGaugeChart(targetId, 'weight', size);
    }
    ChartGeneratorService.updateGaugeChart(Number(targetData.current), weightMainChart, targetId);




  };

  vm.setTeamCaloryBurnInfo = function (userId, tId, type) {


    var targetData = _.find(vm.bioList, {
      user_id: userId
    })['calrorie_burned'][0];

    let chartHtml = `<div class="w3-cell-row" style="height:100%">
        <div id="${type}-main-chart-${tId}" class="w3-cell w3-cell-middle" style="width:50%; height:100%">
          </div>
        <div class="w3-cell w3-cell-middle" style="width:50%; height:100%">
          칼로리소모<br><strong>${targetData.current}</strong>kcal
          </div>
      </div>`;

    angular.element('#' + tId).html(chartHtml);

    let targetId = "#" + 'caloryburn-main-chart-' + tId;



    let value = Number(targetData.current); //water.current
    //heartbeat.max 값이 0일경우 챠트 에러가 발생 하므로 임의로 100 부여
    let max = targetData.max ? Number(targetData.max) : 100;

    //liquid gauge chart
    let caloryBurnMainChart;
    let options = ChartGeneratorService.getLiquidGaugeOptions();
    options.targetId = targetId;
    options.svgId = 'caloryburn-liquid';
    options.circleColor = '#c833c8';
    options.textColor = '#c833c8';
    options.waveColor = '#c833c8';
    options.size = liquidGaugeSize;
    let dataValue = (value / max) * 100;
    if (!caloryBurnMainChart) {
      caloryBurnMainChart = ChartGeneratorService.loadLiquidFillGauge(Math.round(dataValue), options);
      caloryBurnMainChart['type'] = 'liquid';
    } else {
      caloryBurnMainChart.update(Math.round(dataValue));
    }

  };

  vm.setTeamCaloryGetInfo = function (userId, tId, type) {

    var targetData = _.find(vm.bioList, {
      user_id: userId
    })['calrorie_get'][0];

    // let chartHtml = "<div id='calory-main-chart-" + tId + "' class='team-main-min-chart-container'></div>" +
    //   "<p>칼로리섭취<strong>" + targetData.current + "</strong>kcal</p>";
    // angular.element('#' + tId).html(chartHtml);

    // let targetId = "#" + 'calory-main-chart-' + tId;

    let chartHtml = `<div class="w3-cell-row" style="height:100%">
        <div id="calory-main-chart-${tId}" class="w3-cell w3-cell-middle" style="width:50%; height:100%">
          </div>
        <div class="w3-cell w3-cell-middle" style="width:50%; height:100%">
          칼로리섭취<br><strong>${targetData.current}</strong>kcal
          </div>
      </div>`;

    angular.element('#' + tId).html(chartHtml);

    let targetId = "#" + 'calory-main-chart-' + tId;

    let value = Number(targetData.current); //water.current
    //heartbeat.max 값이 0일경우 챠트 에러가 발생 하므로 임의로 100 부여
    let max = targetData.max ? Number(targetData.max) : 100;

    //liquid gauge chart
    let caloryGetMainChart;
    let options = ChartGeneratorService.getLiquidGaugeOptions();
    options.targetId = targetId;
    options.svgId = 'calory-liquid';
    options.circleColor = '#c833c8';
    options.textColor = '#c833c8';
    options.waveColor = '#c833c8';
    options.size = liquidGaugeSize;
    let dataValue = (value / max) * 100;
    if (!caloryGetMainChart) {
      caloryGetMainChart = ChartGeneratorService.loadLiquidFillGauge(Math.round(dataValue), options);
      caloryGetMainChart['type'] = 'liquid';
    } else {
      caloryGetMainChart.update(Math.round(dataValue));
    }

  };

  vm.setTeamWaterInfo = function (userId, tId, type) {

    var targetData = _.find(vm.bioList, {
      user_id: userId
    })['water'][0];
    console.log('targetData', targetData)

    let chartHtml = `<div class="w3-cell-row" style="height:100%">
        <div id="${type}-main-chart-${tId}" class="w3-cell w3-cell-middle" style="width:50%; height:100%">
          </div>
        <div class="w3-cell w3-cell-middle" style="width:50%; height:100%">
          <strong>${targetData.current}</strong> ml of water
          </div>
      </div>`;

    angular.element('#' + tId).html(chartHtml);

    let targetId = "#" + 'water-main-chart-' + tId;




    let value = Number(targetData.current); //water.current
    //heartbeat.max 값이 0일경우 챠트 에러가 발생 하므로 임의로 100 부여
    let max = targetData.max ? Number(targetData.max) : 100;

    //liquid gauge chart
    let waterMainChart;
    let options = ChartGeneratorService.getLiquidGaugeOptions();
    options.targetId = targetId;
    options.svgId = 'water-liquid';
    options.circleColor = '#3187c5';
    options.textColor = '#3187c5';
    options.waveColor = '#3187c5';
    options.size = liquidGaugeSize;
    let dataValue = (value / max) * 100;
    if (!waterMainChart) {
      waterMainChart = ChartGeneratorService.loadLiquidFillGauge(Math.round(dataValue), options);
      waterMainChart['type'] = 'liquid';
    } else {
      waterMainChart.update(Math.round(dataValue));
    }

  };




  vm.setTeamSleepInfo = function (userId, tId, type) {

    var targetData = _.find(vm.bioList, {
      user_id: userId
    })['sleep'][0];

    // let chartHtml = "<div id='sleep-main-chart-" + tId + "' class='team-main-min-chart-container'></div>" +
    //   "<p>수면<br>" + targetData.current.hour + "시간" + targetData.current.minute + "분</p>";
    // angular.element('#' + tId).html(chartHtml);

    // let targetId = "#" + 'sleep-main-chart-' + tId;

    let chartHtml = `<div class="w3-cell-row" style="height:100%">
        <div id="${type}-main-chart-${tId}" class="w3-cell w3-cell-middle" style="width:50%; height:100%">
          </div>
        <div class="w3-cell w3-cell-middle" style="width:50%; height:100%">
          sleep<br><strong>${targetData.current.hour} hours ${targetData.current.minute} minutes</strong>
          </div>
      </div>`;

    angular.element('#' + tId).html(chartHtml);

    let targetId = "#" + 'sleep-main-chart-' + tId;


    // 분을 퍼센트로 바꾼다.
    var currentMinute = parseInt(Number(targetData.current.minute) / 60 * 100);
    var currentValue = Number(targetData.current.hour + '.' + currentMinute);

    var targetMinute = parseInt(Number(targetData.target.minute) / 60 * 100);
    var targetValue = Number(targetData.target.hour + '.' + targetMinute);

    let value = currentValue; //weight.current
    let max = targetValue; //weight.target

    //liquid gauge chart
    let sleepMainChart;
    let options = ChartGeneratorService.getLiquidGaugeOptions();
    options.targetId = targetId;
    options.svgId = 'sleep-liquid';
    options.circleColor = '#27f72d';
    options.textColor = '#27f72d';
    options.waveColor = '#27f72d';
    options.size = liquidGaugeSize;
    let dataValue = (value / max) * 100;
    if (!sleepMainChart) {
      sleepMainChart = ChartGeneratorService.loadLiquidFillGauge(Math.round(dataValue), options);
      sleepMainChart['type'] = 'liquid';
    } else {
      sleepMainChart.update(Math.round(dataValue));
    }

  };

  vm.setTeamInjuryInfo = function (userId, tId, type) {
    var targetData = _.find(vm.bioList, {
      user_id: userId
    })['injury'][0];

    // let chartHtml = "<p style='width:100%;padding-top:25px;'>" + targetData.norm.status + "<strong> " + targetData.norm.day + "</strong> day</p>";

    let chartHtml = `<div class="w3-cell-row" style="height:100%">
        <div class="w3-cell w3-cell-middle" style="width:100%; height:100%">
          <h5>${targetData.current.day} days in treatment</h5>
          </div>
      </div>`;




    angular.element('#' + tId).html(chartHtml);
  };

  vm.setTeamLocationInfo = function (userId, tId, type) {

    if (!vm.teamInfoList) {
      toastr.info('현재 데이터를 불러오는 중입니다. 잠시후 다시 선택해주세요');
      return;
    }



    let chartHtml = `<div class="w3-cell-row" style="height:100%">
        <div id="movement-main-chart-${tId}" class="w3-cell w3-cell-middle" style="width:100%; height:100%">
          
        </div>
      </div>`;

    angular.element('#' + tId).html(chartHtml);
    let targetId = "#" + 'movement-main-chart-' + tId;



    // console.log('vm.teamInfoList ...... return', vm.teamInfoList);
    // return;

    var targetData = _.find(vm.teamInfoList, {
      user_id: userId
    })['movements'][0];


    // console.log('targetData', targetData);
    // return;
    // console.log('selectedData ...........', selectedData);
    // let skillIdx = $('#movement option').index($('#movement option:selected'));
    let data = {
      name: targetData.name,
      total: targetData.total,
      success: targetData.suc,
      right: targetData.right,
      left: targetData.left
    };
    // vm.playerSkillData = data;
    // let skillKeyName = 'skill';
    // let targetId = '#player-skill-main-chart';

    // console.log('data', data);
    // return;

    $(targetId).html('');
    let successPer = (data.success / data.total) * 100;
    if (Number.isNaN(successPer)) {
      successPer = 0; //임시 값 제거
    }
    let rightPer = (data.right / (data.right + data.left)) * 100;
    if (Number.isNaN(rightPer)) {
      rightPer = 0; //임시 값 제거
    }

    let dataset = [{
        data: [{
            title: '성공',
            count: successPer //성공
          },
          {
            title: '발',
            count: rightPer //오른발
          }
        ]
      },
      {
        data: [{
            title: '성공',
            count: 100 - successPer //실패
          },
          {
            title: '발',
            count: successPer - rightPer //왼발
          }
        ]
      }
    ];
    console.log('dataset', dataset);
    ChartGeneratorService.createStackedBarChart(targetId, data);






  }

  vm.setTeamLungCapacity = function (userId, tId, type) {

    // var targetData = vm.teamBioDataList[userId]['lung_capacity_1'][0];
    var targetData = _.find(vm.bioList, {
      user_id: userId
    })['lung_capacity'][0];

    let chartHtml = `<div class="w3-cell-row" style="height:100%">
        <div id="${type}-main-chart-${tId}" class="w3-cell w3-cell-middle" style="width:50%; height:100%">
          </div>
        <div class="w3-cell w3-cell-middle" style="width:50%; height:100%">
          호흡<br>
          <strong>${targetData.current}</strong>ml<br>
          </div>
      </div>`;
    angular.element('#' + tId).html(chartHtml);
    let targetId = 'lung_capacity_1-main-chart-' + tId;

    let weightMainChart;
    if (!weightMainChart) {
      let size = 70;
      weightMainChart = ChartGeneratorService.createGaugeChart(targetId, 'weight', size);
    }
    ChartGeneratorService.updateGaugeChart(Number(targetData.current), weightMainChart, targetId);



  }

  //   //endregion









  var render = function () {


    _.forEach(_.filter(vm.players, 'selected'), function (player) {
      angular.element('#' + player.user_id + '-0').html('');
      angular.element('#' + player.user_id + '-1').html('');
      angular.element('#' + player.user_id + '-2').html('');
      angular.element('#' + player.user_id + '-3').html('');

    })


    _.forEach(vm.bioSelected, function (type, index) {


      _.forEach(_.filter(vm.players, 'selected'), function (player) {
        var id = player.user_id + '-' + index;
        var userId = player.user_id;
        angular.element('#' + id).html('');


        // toastr.info(type);

        switch (type) {
          case 'heartbeat':
            { //심박수
              vm.setTeamHeartbeatInfo(userId, id, type);
              break;
            }
          case 'oxyzen':
            { //SpO2
              vm.setTeamOxygenInfo(userId, id, type);
              // vm.setTeamHeartbeatInfo(userId, id, type);
              break;
            }
          case 'lactic':
            { //젖산
              vm.setTeamLacticInfo(userId, id, type);
              break;
            }
          case 'temperature':
            { //체온
              vm.setTeamTemperatureInfo(userId, id, type);
              break;
            }
          case 'distance':
            { //거리
              vm.setTeamDistanceInfo(userId, id, type);
              break;
            }
          case 'velocity':
            { //속도
              vm.setTeamVelocityInfo(userId, id, type);
              break;
            }
          case 'weight':
            {
              vm.setTeamWeightInfo(userId, id, type);
              break;
            }
          case 'sleep':
            {
              vm.setTeamSleepInfo(userId, id, type);
              break;
            }
          case 'water':
            {
              vm.setTeamWaterInfo(userId, id, type);
              break;
            }
          case 'caloryget':
            {
              vm.setTeamCaloryGetInfo(userId, id, type);
              break;
            }
          case 'caloryburn':
            {
              vm.setTeamCaloryBurnInfo(userId, id, type);
              break;
            }
          case 'injury':
            {
              vm.setTeamInjuryInfo(userId, id, type);
              break;
            }
          case 'location':
            {
              vm.setTeamLocationInfo(userId, id, type);
              break;
            }
          case 'lung_capacity_1':
            {
              vm.setTeamLungCapacity(userId, id, type);
              break;
            }
            //
        }



      })

    })

  }











  vm.userInfo = {
    // user_id: $rootScope.selectPlayerInfo.user_id,
    user_id: $stateParams.user_id,
    mode: ''
  };

  // 히트맵 탭모드 초기화
  vm.activeHeatmapTab = 'att';
  // 히트맵 포지션 정보
  vm.heatmapPos = {
    'A-CK-R': {
      x: 12,
      y: 12,
      radius: 30
    }, //A면 코너킥 오른쪽 - A-CK-R
    'A-CK-L': {
      x: 12,
      y: 232,
      radius: 30
    }, //A면 코너킥 왼쪽 - A-CK-L
    'B-CK-L': {
      x: 308,
      y: 232,
      radius: 30
    }, //B면 코너킥 왼쪽 - B-CK-L
    'B-CK-L': {
      x: 308,
      y: 12,
      radius: 30
    }, //B면 코너킥 왼쪽 - B-CK-L
    //코너킥 -end
    //오른쪽 -start
    'A-PA-CK-R': {
      x: 33,
      y: 30,
      radius: 30
    }, //A면 페널티 에어리어 코너 부근 오른쪽 - A-PA-CK-R
    'A-AK-TL-R': {
      x: 95,
      y: 30,
      radius: 30
    }, //A면 아크서클 터치라인 부근 오른쪽 - A-AK-TL-R
    'A-MF-TL-R': {
      x: 120,
      y: 30,
      radius: 30
    }, //A면 미드필드 터치라인 부근 오른쪽 - A-MF-TL-R
    'A-HL-TL-R': {
      x: 150,
      y: 30,
      radius: 30
    }, //A면 하프라인 터치라인 부근 오른쪽 - A-HL-TL-R
    'B-PA-CK-R': {
      x: 320 - 33,
      y: 30,
      radius: 30
    }, //B면 페널티 에어리어 코너 부근 오른쪽 - B-PA-CK-R
    'B-AK-TL-R': {
      x: 320 - 95,
      y: 30,
      radius: 30
    }, //B면 아크서클 터치라인 부근 오른쪽 - B-AK-TL-R
    'B-MF-TL-R': {
      x: 320 - 120,
      y: 30,
      radius: 30
    }, //B면 미드필드 터치라인 부근 오른쪽 - B-MF-TL-R
    'B-HL-TL-R': {
      x: 320 - 150,
      y: 30,
      radius: 30
    }, //B면 하프라인 터치라인 부근 오른쪽 - B-HL-TL-R
    'A-PA-OUT-EL-R': {
      x: 18,
      y: 44,
      radius: 30
    }, //A면 페널티 에어리어 바깥쪽 엔드라인 부근 오른쪽 - A-PA-OUT-EL-R
    'A-PA-OUT-SD-R': {
      x: 57,
      y: 44,
      radius: 30
    }, //A면 페널티 에어리어 바깥쪽 사이드 부근 오른쪽 - A-PA-OUT-SD-R
    'B-PA-OUT-EL-R': {
      x: 320 - 18,
      y: 44,
      radius: 30
    }, //B면 페널티 에어리어 바깥쪽 엔드라인 부근 오른쪽 - B-PA-OUT-EL-R
    'B-PA-OUT-SD-R': {
      x: 320 - 57,
      y: 44,
      radius: 30
    }, //B면 페널티 에어리어 바깥쪽 사이드 부근 오른쪽 - B-PA-OUT-SD-R
    'A-PA-IN-EL-R': {
      x: 18,
      y: 74,
      radius: 30
    }, //A면 페널티 에어리어 안쪽 엔드라인 부근 오른쪽 - A-PA-IN-EL-R
    'A-PA-OUT-FR-R': {
      x: 70,
      y: 74,
      radius: 30
    }, //A면 페널티 에어리어 바깥쪽 정면 부근 오른쪽 - A-PA-OUT-FR-R
    'A-MF-R': {
      x: 120,
      y: 74,
      radius: 30
    }, //A면 미드필드 부근 오른쪽 - A-MF-R
    'B-PA-IN-EL-R': {
      x: 320 - 18,
      y: 74,
      radius: 30
    }, //B면 페널티 에어리어 안쪽 엔드라인 부근 오른쪽 - B-PA-IN-EL-R
    'B-PA-OUT-FR-R': {
      x: 320 - 70,
      y: 74,
      radius: 30
    }, //B면 페널티 에어리어 바깥쪽 정면 부근 오른쪽 - B-PA-OUT-FR-R
    'B-MF-R': {
      x: 320 - 120,
      y: 74,
      radius: 30
    }, //B면 미드필드 부근 오른쪽 - B-MF-R
    'A-GA-OUT-FR-R': {
      x: 40,
      y: 84,
      radius: 30
    }, //A면 골 에어리어 바깥쪽 정면 부근 오른쪽 - A-GA-OUT-FR-R
    'A-HL-R': {
      x: 150,
      y: 84,
      radius: 30
    }, //A면 하프라인 오른쪽 - A-HL-R
    'B-GA-OUT-FR-R': {
      x: 320 - 40,
      y: 84,
      radius: 30
    }, //B면 골 에어리어 바깥쪽 정면 부근 오른쪽 - B-GA-OUT-FR-R
    'B-HL-R': {
      x: 320 - 150,
      y: 84,
      radius: 30
    }, //B면 하프라인 오른쪽 - B-HL-R
    'A-GA-IN-EL-R': {
      x: 18,
      y: 102,
      radius: 30
    }, //A면 골 에어리어 안쪽 엔드라인 오른쪽 - A-GA-IN-EL-R
    'A-GA-IN-R': {
      x: 27,
      y: 102,
      radius: 30
    }, //A면 골 에어리어 안쪽 오른쪽 - A-GA-IN-R
    'A-PA-IN-FR-R': {
      x: 57,
      y: 102,
      radius: 30
    }, //A면 페널티 에어리어 안쪽 정면 부근 오른쪽 - A-PA-IN-FR-R
    'A-AK-R': {
      x: 95,
      y: 102,
      radius: 30
    }, //A면 아크서클 부근 오른쪽 - A-AK-R
    'B-GA-IN-EL-R': {
      x: 320 - 18,
      y: 102,
      radius: 30
    }, //B면 골 에어리어 안쪽 엔드라인 오른쪽 - B-GA-IN-EL-R
    'B-GA-IN-R': {
      x: 320 - 27,
      y: 102,
      radius: 30
    }, //B면 골 에어리어 안쪽 오른쪽 - B-GA-IN-R
    'B-PA-IN-FR-R': {
      x: 320 - 57,
      y: 102,
      radius: 30
    }, //B면 페널티 에어리어 안쪽 정면 부근 오른쪽 - B-PA-IN-FR-R
    'B-AK-R': {
      x: 320 - 95,
      y: 102,
      radius: 30
    }, //B면 아크서클 부근 오른쪽 - B-AK-R
    'A-GA-IN-GK-R': {
      x: 18,
      y: 112,
      radius: 30
    }, //A면 골 에어리어 안쪽 골킥 부근 오른쪽 - A-GA-IN-GK-R
    'A-PK-R': {
      x: 48,
      y: 112,
      radius: 30
    }, //A면 페널티킥 부근 오른쪽 - A-PK-R
    'B-GA-IN-GK-R': {
      x: 320 - 18,
      y: 112,
      radius: 30
    }, //B면 골 에어리어 안쪽 골킥 부근 오른쪽 - B-GA-IN-GK-R
    'B-PK-R': {
      x: 320 - 48,
      y: 112,
      radius: 30
    }, //B면 페널티킥 부근 오른쪽 - B-PK-R
    //오른쪽 -end
    //센터 -start
    'A-GA-IN-GK-C': {
      x: 18,
      y: 122,
      radius: 30
    }, //A면 골 에어리어 안쪽 골킥 부근 가운데 - A-GA-IN-GK-C
    'A-GA-IN-C': {
      x: 27,
      y: 122,
      radius: 30
    }, //A면 골 에어리어 안쪽 가운데 - A-GA-IN-C
    'A-GA-IN-C': {
      x: 40,
      y: 122,
      radius: 30
    }, //A면 골 에어리어 바깥쪽 정면 부근 가운데 - A-GA-IN-C
    'A-PK-C': {
      x: 48,
      y: 122,
      radius: 30
    }, //A면 페널티킥 부근 가운데 - A-PK-C
    'A-PA-IN-FR-C': {
      x: 57,
      y: 122,
      radius: 30
    }, //A면 페널티 에어리어 안쪽 정면 부근 가운데 - A-PA-IN-FR-C
    'A-PA-OUT-FR-C': {
      x: 70,
      y: 122,
      radius: 30
    }, //A면 페널티 에어리어 바깥쪽 정면 부근 가운데 - A-PA-OUT-FR-C
    'A-AK-C': {
      x: 95,
      y: 122,
      radius: 30
    }, //A면 아크서클 부근 가운데 - A-AK-C
    'A-MF-C': {
      x: 120,
      y: 122,
      radius: 30
    }, //A면 미드필드 부근 가운데 - A-MF-C
    'A-HL-C': {
      x: 150,
      y: 122,
      radius: 30
    }, //A면 하프라인 가운데 - A-HL-C
    'B-GA-IN-GK-C': {
      x: 320 - 18,
      y: 122,
      radius: 30
    }, //B면 골 에어리어 안쪽 골킥 부근 가운데 - B-GA-IN-GK-C
    'B-GA-IN-C': {
      x: 320 - 27,
      y: 122,
      radius: 30
    }, //B면 골 에어리어 안쪽 가운데 - B-GA-IN-C
    'B-GA-OUT-FR-C': {
      x: 320 - 40,
      y: 122,
      radius: 30
    }, //B면 골 에어리어 바깥쪽 정면 부근 가운데 - B-GA-OUT-FR-C
    'B-PK-C': {
      x: 320 - 48,
      y: 122,
      radius: 30
    }, //B면 페널티킥 부근 가운데 - B-PK-C
    'B-PA-IN-FR-C': {
      x: 320 - 57,
      y: 122,
      radius: 30
    }, //B면 페널티 에어리어 안쪽 정면 부근 가운데 - B-PA-IN-FR-C
    'B-PA-OUT-FR-C': {
      x: 320 - 70,
      y: 122,
      radius: 30
    }, //B면 페널티 에어리어 바깥쪽 정면 부근 가운데 - B-PA-OUT-FR-C
    'B-AK-C': {
      x: 320 - 95,
      y: 122,
      radius: 30
    }, //B면 아크서클 부근 가운데 - B-AK-C
    'B-MF-C': {
      x: 320 - 120,
      y: 122,
      radius: 30
    }, //B면 미드필드 부근 가운데 - B-MF-C
    'B-HL-C': {
      x: 320 - 150,
      y: 122,
      radius: 30
    }, //B면 하프라인 가운데 - B-HL-C
    //센터 -end
    //왼쪽 -start
    'A-GA-IN-GK-L': {
      x: 18,
      y: 132,
      radius: 30
    }, //A면 골 에어리어 안쪽 골킥 부근 왼쪽 - A-GA-IN-GK-L
    'A-PK-L': {
      x: 48,
      y: 132,
      radius: 30
    }, //A면 페널티킥 부근 왼쪽 - A-PK-L
    'B-GA-IN-GK-L': {
      x: 320 - 18,
      y: 132,
      radius: 30
    }, //B면 골 에어리어 안쪽 골킥 부근 왼쪽 - B-GA-IN-GK-L
    'B-PK-L': {
      x: 320 - 48,
      y: 132,
      radius: 30
    }, //B면 페널티킥 부근 왼쪽 - B-PK-L
    'A-GA-IN-EL-L': {
      x: 18,
      y: 142,
      radius: 30
    }, //A면 골 에어리어 안쪽 엔드라인 왼쪽 - A-GA-IN-EL-L
    'A-GA-IN-L': {
      x: 27,
      y: 142,
      radius: 30
    }, //A면 골 에어리어 안쪽 왼쪽 - A-GA-IN-L
    'A-PA-IN-FR-L': {
      x: 57,
      y: 142,
      radius: 30
    }, //A면 페널티 에어리어 안쪽 정면 부근 왼쪽 - A-PA-IN-FR-L
    'A-AK-L': {
      x: 95,
      y: 142,
      radius: 30
    }, //A면 아크서클 부근 왼쪽 - A-AK-L
    'B-GA-IN-EL-L': {
      x: 320 - 18,
      y: 142,
      radius: 30
    }, //B면 골 에어리어 안쪽 엔드라인 왼쪽 - B-GA-IN-EL-L
    'B-GA-IN-L': {
      x: 320 - 27,
      y: 142,
      radius: 30
    }, //B면 골 에어리어 안쪽 왼쪽 - B-GA-IN-L
    'B-PA-IN-FR-L': {
      x: 320 - 57,
      y: 142,
      radius: 30
    }, //B면 페널티 에어리어 안쪽 정면 부근 왼쪽 - B-PA-IN-FR-L
    'B-AK-L': {
      x: 320 - 95,
      y: 142,
      radius: 30
    }, //B면 아크서클 부근 왼쪽 - B-AK-L
    'A-GA-OUT-FR-L': {
      x: 40,
      y: 160,
      radius: 30
    }, //A면 골 에어리어 바깥쪽 정면 부근 왼쪽 - A-GA-OUT-FR-L
    'A-HL-L': {
      x: 150,
      y: 160,
      radius: 30
    }, //A면 하프라인 왼쪽 - A-HL-L
    'B-GA-OUT-FR-L': {
      x: 320 - 40,
      y: 160,
      radius: 30
    }, //B면 골 에어리어 바깥쪽 정면 부근 왼쪽 - B-GA-OUT-FR-L
    'B-HL-L': {
      x: 320 - 150,
      y: 160,
      radius: 30
    }, //B면 하프라인 왼쪽 - B-HL-L
    'A-PA-IN-EL-L': {
      x: 18,
      y: 170,
      radius: 30
    }, //A면 페널티 에어리어 안쪽 엔드라인 부근 왼쪽 - A-PA-IN-EL-L
    'A-PA-OUT-FR-L': {
      x: 70,
      y: 170,
      radius: 30
    }, //A면 페널티 에어리어 바깥쪽 정면 부근 왼쪽 - A-PA-OUT-FR-L
    'A-MF-L': {
      x: 120,
      y: 170,
      radius: 30
    }, //A면 미드필드 부근 왼쪽 - A-MF-L
    'B-PA-IN-EL-L': {
      x: 320 - 18,
      y: 170,
      radius: 30
    }, //B면 페널티 에어리어 안쪽 엔드라인 부근 왼쪽 - B-PA-IN-EL-L
    'B-PA-OUT-FR-L': {
      x: 320 - 70,
      y: 170,
      radius: 30
    }, //B면 페널티 에어리어 바깥쪽 정면 부근 왼쪽 - B-PA-OUT-FR-L
    'B-MF-L': {
      x: 320 - 120,
      y: 170,
      radius: 30
    }, //B면 미드필드 부근 왼쪽 - B-MF-L
    'A-PA-OUT-EL-L': {
      x: 18,
      y: 200,
      radius: 30
    }, //A면 페널티 에어리어 바깥쪽 엔드라인 부근 왼쪽 - A-PA-OUT-EL-L
    'A-PA-OUT-SD-L': {
      x: 57,
      y: 200,
      radius: 30
    }, //A면 페널티 에어리어 바깥쪽 사이드 부근 왼쪽 - A-PA-OUT-SD-L
    'B-PA-OUT-EL-L': {
      x: 320 - 18,
      y: 200,
      radius: 30
    }, //B면 페널티 에어리어 바깥쪽 엔드라인 부근 왼쪽 - B-PA-OUT-EL-L
    'B-PA-OUT-SD-L': {
      x: 320 - 57,
      y: 200,
      radius: 30
    }, //B면 페널티 에어리어 바깥쪽 사이드 부근 왼쪽 - B-PA-OUT-SD-L
    'A-PA-CK-L': {
      x: 33,
      y: 214,
      radius: 30
    }, //A면 페널티 에어리어 코너 부근 왼쪽 - A-PA-CK-L
    'A-AK-TL-L': {
      x: 95,
      y: 214,
      radius: 30
    }, //A면 아크서클 터치라인 부근 왼쪽 - A-AK-TL-L
    'A-MF-TL-L': {
      x: 120,
      y: 214,
      radius: 30
    }, //A면 미드필드 터치라인 부근 왼쪽 - A-MF-TL-L
    'A-HL-TL-L': {
      x: 150,
      y: 214,
      radius: 30
    }, //A면 하프라인 터치라인 부근 왼쪽 - A-HL-TL-L
    'B-PA-CK-L': {
      x: 320 - 33,
      y: 214,
      radius: 30
    }, //B면 페널티 에어리어 코너 부근 왼쪽 - B-PA-CK-L
    'B-AK-TL-L': {
      x: 320 - 95,
      y: 214,
      radius: 30
    }, //B면 아크서클 터치라인 부근 왼쪽 - B-AK-TL-L
    'B-MF-TL-L': {
      x: 320 - 120,
      y: 214,
      radius: 30
    }, //B면 미드필드 터치라인 부근 왼쪽 - B-MF-TL-L
    'B-HL-TL-L': {
      x: 320 - 150,
      y: 214,
      radius: 30
    }, //B면 하프라인 터치라인 부근 왼쪽 - B-HL-TL-L
  }

  vm.playerTotalInfo = {}; //main/info 결과값을 모두 저장하는 변수
  let dateObj = new Date();
  let year = dateObj.getFullYear();
  let month = dateObj.getMonth() + 1;
  let date = dateObj.getDate();
  if (month < 10) {
    month = '0' + month;
  }
  if (date < 10) {
    date = '0' + date;
  }
  vm.startDate = `${year}-${month}-${date}`;
  vm.endDate = `${year}-${month}-${date + 1}`;

  $scope.$on('$viewContentLoaded', function (event) {
    $('#startDate').each(function () {
        //   console.log($element);
        new Flatpickr(document.getElementById('startDate'), {
          minDate: "today",
          locale: Korean,
          dateFormat: 'Y-m-d',
          onChange: function (selectedDates, dateStr, instance) {
            vm.startDate = selectedDates;
          }
        });
      }),
      $('#endDate').each(function () {
        new Flatpickr(this, {
          minDate: "today",
          locale: Korean,
          dateFormat: 'Y-m-d',
          onChange: function (selectedDates, dateStr, instance) {
            vm.endDate = selectedDates;
          }
        });
      });
  });

  /**
   * 선수의 종합적인 생체정보 조회
   */
  let chartPadding = {
    top: 0,
    bottom: 0,
    left: 30,
    right: 5
  };

  vm.metaData = {
    movements: null,
    locations: null,
    foots: null
  };
  vm.selectedSkill = null;
  vm.selectedLocation = null;
  vm.selectedFoot = null;

  //경기장 위치 데이터 조회
  AnalysisService.getLocationList().then(function (res) {
    vm.metaData.locations = res.data.data;
    vm.metaData.locations.unshift({
      id: 0,
      name: '전체'
    });
    vm.selectedLocation = vm.metaData.locations[0];
  });

  vm.mode = JSON.parse($window.sessionStorage.getItem('mode'))

  /*
  vm.getPlayerBiometricInfo = function (mode, from, to) {
    vm.mode = mode;
    $window.sessionStorage.setItem('mode', JSON.stringify(vm.mode));
    $window.sessionStorage.setItem('from', JSON.stringify(vm.from));
    $window.sessionStorage.setItem('to', JSON.stringify(vm.to));
    var data = {
      mode: mode
    }
    if (mode == 'user') {
      data.from = vm.startDate.replace(/./g, '');
      data.to = vm.endDate.replace(/./g, '');
    }
    $scope.mode = mode;
    vm.userInfo.mode = mode;

    // 우리팀 bio
    data.team_id = vm.appContext.my_team.team_id;
    PlayerService.getPlayerBiometricInfo(data)
      .then(function (res) {
        var myTeamBioList = res.data.list;
        // 상대팀 bio
        data.team_id = vm.appContext.oppo_team.team_id;
        PlayerService.getPlayerBiometricInfo(data)
          .then(function (res) {
            var oppoTeamBioList = res.data.list;
            vm.bioList = myTeamBioList.concat(oppoTeamBioList);
            console.log('vm.bioList', vm.bioList);
          })
          .catch(function (error) {
            console.log("An error occured : " + error);
          })
      })
      .catch(function (error) {
        console.log("An error occured : " + error);
      })


    data.team_id = vm.appContext.my_team.team_id;
    PlayerService.getPlayerLocationInfo(data)
      .then(function (res) {
        var myTeamInfoList = res.data.list;
        data.team_id = vm.appContext.oppo_team.team_id;
        PlayerService.getPlayerLocationInfo(data)
          .then(function (res) {
            var oppoTeamInfoList = res.data.list;
            vm.teamInfoList = myTeamInfoList.concat(oppoTeamInfoList);
            console.log('vm.teamInfoList', vm.teamInfoList);
          })
          .catch(function (error) {
            console.log("An error occured : " + error);
          })
      })
      .catch(function (error) {
        console.log("An error occured : " + error);
      })

  };
*/


  vm.getPlayerBiometricInfo = function (mode, from, to, force) {

    if (!force) {
      count++;
      if ($stateParams.type_code === 'game' && count !== 4) {
        return;
      }

      if ($stateParams.type_code != 'game' && count !== 1) {
        return;
      }
    }

    vm.mode = mode;
    $window.sessionStorage.setItem('mode', JSON.stringify(vm.mode));
    $window.sessionStorage.setItem('from', JSON.stringify(vm.from));
    $window.sessionStorage.setItem('to', JSON.stringify(vm.to));
    var data = {
      mode: mode
    }
    if (mode == 'user') {
      if (!from || !to) {
        toastr.error('시작일과 종료일을 선택해주십시오');
        return;
      }

      data.from = vm.from.replace(/\./g, '');
      data.to = vm.to.replace(/\./g, '');

      vm.showSearchDropdown = false;
      vm.showCustomPeriod = false;
    }
    $scope.mode = mode;
    vm.userInfo.mode = mode;

    // console.log('vm.appContext', vm.appContext)
    // console.log('vm.appContext', vm.appContext.players.game.my_team.entryMain)
    // 


    if ($stateParams.type_code === 'game') {
      var arr = vm.appContext.players.game.my_team.entryMain
        .concat(vm.appContext.players.game.my_team.entryBackup)
        .concat(vm.appContext.players.game.oppo_team.entryMain)
        .concat(vm.appContext.players.game.oppo_team.entryBackup);
      var users = _.map(arr, 'user_id');

      // 경기관리에서 선수분석으로 들어온 경우 mode 를 game_id 로 설정함
      data.mode = $stateParams.id;
    }

    if ($stateParams.type_code === 'training') {
      var arr = vm.appContext.players.training.my_team.entryMain;
      var users = _.map(arr, 'user_id');
    }

    if ($stateParams.type_code === 'team') {
      var arr = vm.appContext.players.all;
      var users = _.map(arr, 'user_id');
    }


    vm.users = users;
    vm.bioList = [];
    vm.teamInfoList = [];

    users.forEach(function (user, i) {

      (function(user) {
        setTimeout(function() {
          data.user_id = user;
          PlayerService.getPlayerBiometricInfo(data)
            .then(function (res) {
              vm.bioList.push(res.data)
              vm.teamInfoList.push({
                user_id: res.data.user_id,
                name: res.data.name,
                movements: res.data.movements,
                locations: res.data.locations
              })
            })
            .catch(function (error) {
              console.log("An error occured : " + error);
            })
        }, i * 50);
      })(user);
      
    })

  };

  var count = 0;
  if ($stateParams.type_code === 'team') {
    $scope.$watch('vm.appContext.players.all', function (newVal, oldVal) {
      if (newVal) {
        vm.getPlayerBiometricInfo('recent');
      }
    }, true)
  }

  if ($stateParams.type_code === 'training') {
    $scope.$watch('vm.appContext.players.training.my_team.entryMain', function (newVal, oldVal) {
      if (newVal) {
        vm.getPlayerBiometricInfo('recent');
      }
    }, true)
  }

  if ($stateParams.type_code === 'game') {
    $scope.$watch('vm.appContext.players.game.my_team.entryMain', function (newVal, oldVal) {
      if (newVal) {
        vm.getPlayerBiometricInfo('recent');
      }
    }, true)

    $scope.$watch('vm.appContext.players.game.my_team.entryBackup', function (newVal, oldVal) {
      if (newVal) {
        vm.getPlayerBiometricInfo('recent');
      }
    }, true)

    $scope.$watch('vm.appContext.players.game.oppo_team.entryMain', function (newVal, oldVal) {
      if (newVal) {
        vm.getPlayerBiometricInfo('recent');
      }
    }, true)

    $scope.$watch('vm.appContext.players.game.oppo_team.entryBackup', function (newVal, oldVal) {
      if (newVal) {
        vm.getPlayerBiometricInfo('recent');
      }
    }, true)
  }
}

export default {
  name: 'PlayerCtrl',
  fn: PlayerCtrl
};
